import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BarrierProfile } from '../../entities/barrier-profile';
import { MasterVehicle } from '../../entities/master-vehicle';
import { TypeVehicle } from '../../entities/type-vehicle';
import { BarrierProfileService } from '../../services/barrier-profile.service';
import { MasterVehicleService } from '../../services/master-vehicle.service';
import { TypeVehicleService } from '../../services/type-vehicle.service';

/**
 * Dialog data
 */
export interface DialogData {
  /**
   * Vehicle
   */
  masterVehicleId: string;
}

@Component({
  selector: 'app-edit',
  templateUrl: './edit.component.html',
  styleUrls: ['./edit.component.scss'],
})
export class EditComponent implements OnInit {
  /**
   * Is creating
   */
  isCreating: boolean;

  /**
   * Master Vehicle form
   */
  masterVehicleForm: FormGroup;

  /**
   * Master Vehicle
   */
  masterVehicle: MasterVehicle;

  /**
   * Type Vehicles array
   */
  typeVehicles: TypeVehicle[];

  /**
   * Barrier Profiles array
   */

  booleanValues: any = [
    { id: true, description: 'Si' },
    { id: false, description: 'No' },
  ];
  barrierProfiles: BarrierProfile[];
  constructor(
    public dialogRef: MatDialogRef<EditComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private masterVehicleService: MasterVehicleService,
    private typeVehicleService: TypeVehicleService,
    private barrierProfileService: BarrierProfileService
  ) {}

  /**
   * ngOnInit
   */
  ngOnInit(): void {
    this.masterVehicleForm = new FormGroup({
      plate: new FormControl(null, [Validators.required, Validators.maxLength(20)]),
      owner: new FormControl(null, Validators.maxLength(32)),
      model: new FormControl(null, Validators.maxLength(16)),
      color: new FormControl(null, Validators.maxLength(8)),
      card: new FormControl(null, Validators.maxLength(4)),
      allowed: new FormControl(true, Validators.required),
      // exact: new FormControl(false, Validators.required),
      typeVehicle: new FormControl(null, Validators.required),
      barrierProfile: new FormControl(null, Validators.required),
    });

    if (this.data) {
      this.masterVehicleService.findFiltered({ plate: this.data.masterVehicleId }).subscribe((masterVehicle: any) => {
        if (masterVehicle.length > 0) {
          this.masterVehicle = masterVehicle[0];
          this.isCreating = false;
          for (const i in this.masterVehicleForm.controls) {
            if (this.masterVehicleForm.controls.hasOwnProperty(i)) {
              this.masterVehicleForm.controls[i].setValue(this.masterVehicle[i]);
            }
          }
        }
      });
    } else {
      this.masterVehicle = new MasterVehicle();
      this.isCreating = true;
    }

    this.typeVehicleService.list().subscribe((typeVehicles: TypeVehicle[]) => {
      this.typeVehicles = typeVehicles;
    });

    this.barrierProfileService.list().subscribe((barrierProfiles: BarrierProfile[]) => (this.barrierProfiles = barrierProfiles));
  }

  /**
   * Save master vehicle form
   */
  save(): void {
    for (const i in this.masterVehicleForm.controls) {
      if (this.masterVehicleForm.controls.hasOwnProperty(i) && this.masterVehicleForm.controls[i].value !== null) {
        this.masterVehicle[i] = this.masterVehicleForm.controls[i].value;
      }
    }
    if (this.isCreating) {
      this.masterVehicleService.create(this.masterVehicle).subscribe(() => this.dialogRef.close({}));
    } else {
      delete this.masterVehicle.barrierProfileName;
      delete this.masterVehicle.vehicleTypeName;
      this.masterVehicleService.update(this.masterVehicle).subscribe(() => this.dialogRef.close({}));
    }
  }

  /**
   * Close dialog
   */
  close(): void {
    this.dialogRef.close();
  }
}
